import { FunctionComponent } from "react";

import { classNames } from "@/utils/classNames";

interface TruncatedTextProps {
	value: string | null | undefined;
	maxWidth?: number;
	className?: string;
}

/**
 * A reusable component for displaying truncated text with ellipsis
 */
export const TruncatedText: FunctionComponent<TruncatedTextProps> = ({
	value,
	maxWidth = 200,
	className,
}) => {
	if (!value) {
		return <span className="text-text-disabled">-</span>;
	}

	return (
		<div
			className={classNames("text-ellipsis overflow-hidden whitespace-nowrap", className)}
			style={{ maxWidth: `${maxWidth}px` }}
			title={value}
		>
			{value}
		</div>
	);
};

/**
 * Utility function to truncate a string to a specified length
 */
export const truncateString = (str: string, maxLength: number): string => {
	if (str.length <= maxLength) {
		return str;
	}

	return str.slice(0, maxLength - 1) + "...";
};
